<template>
  <Teleport to="body">
    <div
      v-if="isVisible"
      id="bug-tracker-bubble"
      class="bug-tracker-bubble fixed bottom-6 right-6 z-[99999] cursor-pointer"
      style="position: fixed; bottom: 5rem; right: 0.5rem; z-index: 99999"
      @click="toggleMenu"
    >
      <!-- Bulle principale -->
      <div
        class="w-14 h-14 rounded-full bg-bdc-ocre shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center hover:scale-110"
        :class="{ 'scale-110': isMenuOpen }"
      >
        <Bug class="w-6 h-6 text-white" />
      </div>

      <!-- Menu contextuel -->
      <BugTrackerMenu v-if="isMenuOpen" @close="closeMenu" @action="handleAction" />
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useUserPreferencesStore } from '@/stores/userPreferences'
import { Bug } from 'lucide-vue-next'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import BugTrackerMenu from './BugTrackerMenu.vue'

const authStore = useAuthStore()
const preferencesStore = useUserPreferencesStore()

const isMenuOpen = ref(false)

// Vérifier si la bulle doit être visible
const isVisible = computed(() => {
  if (!authStore.isAuthenticated) {
    console.log('[BdC-BugTrackerBubble] Non authentifié')
    return false
  }

  const role = authStore.userRole
  const hasPermission = role === 'admin' || role === 'researcher'

  if (!hasPermission) {
    console.log('[BdC-BugTrackerBubble] Pas de permission (rôle:', role, ')')
    return false
  }

  const isEnabled = preferencesStore.preferences.bugTrackerEnabled

  /*console.log('[BdC-BugTrackerBubble] Vérification visibilité:', {
    isAuthenticated: authStore.isAuthenticated,
    role,
    hasPermission,
    isEnabled,
    preferences: preferencesStore.preferences,
  })*/

  return hasPermission && isEnabled
})

// Charger les préférences au montage (le cache gère la fréquence de rechargement)
onMounted(async () => {
  if (authStore.isAuthenticated) {
    await preferencesStore.loadPreferences()
  }
})

// Fermer le menu si on clique en dehors
function handleClickOutside(event: MouseEvent) {
  const target = event.target as HTMLElement
  if (!target.closest('.bug-tracker-bubble')) {
    closeMenu()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})

function toggleMenu() {
  isMenuOpen.value = !isMenuOpen.value
  console.log('[BdC-BugTrackerBubble] Menu toggled:', isMenuOpen.value)
}

function closeMenu() {
  isMenuOpen.value = false
}

const emit = defineEmits<{
  action: [action: string]
}>()

function handleAction(action: string) {
  console.log('[BdC-BugTrackerBubble] Action:', action)
  emit('action', action)
  closeMenu()
}
</script>

<style scoped>
.bug-tracker-bubble {
  position: relative;
}
</style>
